import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';
import { EAssignmentMode } from './common-interfaces';

import { UtilsService } from './utils.service';



@Injectable({ providedIn: 'root' })
export class Reports_OperationService {

  constructor(
    private injector: Injector,
    private $utils: UtilsService,
  ) {
  }

  public Reports: Reports_OperationService = this;


  isAssigned(operationName: string, mode: EAssignmentMode): Promise<boolean> {
    return this.$utils.http.post(`${environment.backendUrl}api/Reports/operations/${operationName}/isassigned`, {mode});
  }
}
